<ng-container *ngIf="AppResolutionType !== ResolutionType.Mobile">
  <app-readonly-table [columns]="columns" [isFilterable]="false" [paginator]="false"
    [itemsSource$]="listPayments$" [selectionMode]="null" [isLoadLazy]="false" [totalRecords]="totalRecords">
  </app-readonly-table>
</ng-container>

<ng-container *ngIf="AppResolutionType === ResolutionType.Mobile">
  <ng-container *ngIf="(listPayments$ | async) || [] as payments">
    <div *ngFor="let payment of payments">
      <app-payment-card-mobile [currentPayment]="payment" [columns]="columns">
      </app-payment-card-mobile>
    </div>
    <div *ngIf="payments.length === 0" class="empty-state">
      <i class="pi pi-inbox"></i>
      <p>{{ 'PAYMENTS_DETAILS.NO_RECORDS_FOUND' | translate }}</p>
    </div>
  </ng-container>
</ng-container>
